import * as React from "react";
import { BsBoxArrowUpRight } from "react-icons/bs";

import I18n from "../../I18n";

interface ExternalLinkProps {
  title: string;
  url: string;
}

export function ExternalLink(props: ExternalLinkProps) {
  const { title, url } = props;

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {title}
      <span style={{ background: "#AAAAAAAA" }}>
        <BsBoxArrowUpRight />
        {I18n.t("ext_url.label")}
      </span>
    </a>
  );
}
